module.exports = __webpack_public_path__ + "img/truck-performance.df187fc1.svg";